export const CENTER_POINT_RADIUS = 5;
export const SEG_LINE_Y_STROKE_DASH_ARRAY = 5;

export const SEG_ANALYSIS = {
  mm: 'MM',
  gost: 'GOST',
  astm: 'ASTM',
  sep: 'SEP',
} as const;
